# import AuthResponseFragment from "../fragments/auth-response.graphql"

mutation loginWithGoogle($credential: String!) {
  loginWithGoogle(credential: $credential) {
    ...AuthResponseFragment
  }
}
